import * as apiFactory from "./ApiFactory";

import type { DataPoint } from "@/models/DataPoint";

export async function getDataPoint(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  reference: string,
): Promise<DataPoint> {
  const client = await apiFactory.WithBearer();
  return await client.get<DataPoint>(["/api/datapoints", clientName, brand, caseReference, fileReference, reference]);
}
